import assert from 'assert';
import React from 'react';
import { useTheme } from 'styled-components';
import { ListDataLineChartSC, TachometerBar } from './list-data-line-chart.styled';
import { ListDataLineChartProps } from './list-data-line-chart.types';
import { clamp, getConfigForStatus, GRADIENTS } from './list-data-line-chart.utils';

const ListDataLineChart: React.FunctionComponent<ListDataLineChartProps> = (props) => {
  const {
    values,
    customGradient,
    preset = 'lifeId',
    status,
    className,
    style,
    barStyle,
    pointerColors,
  } = props;
  const [width, setWidth] = React.useState<number | null>(null);
  const theme = useTheme();
  assert(
    !pointerColors || pointerColors.length === values.length,
    'Pointer colors must have same length as values',
  );

  const statusConfig = getConfigForStatus(theme, status);

  return (
    <ListDataLineChartSC className={className} style={style}>
      {statusConfig ? (
        <statusConfig.Icon
          color={statusConfig.color}
          width={16}
          height={16}
          style={{ marginRight: 4 }}
        />
      ) : null}
      <TachometerBar
        className="tachometer-bar"
        onLayout={(e) => setWidth(e.nativeEvent.layout.width)}
        style={barStyle}
      >
        <div
          className="tachometer-bar-track"
          style={{ background: customGradient ?? GRADIENTS[preset] }}
        >
          {width
            ? values.map((v, idx) => (
                <div
                  key={`${v}-${idx}`}
                  className="tachometer-bar-pinter"
                  style={{
                    background: pointerColors ? pointerColors[idx] : 'white',
                    transform: `translateX(${clamp((v / 100) * width, 0, width - 8)}px)`,
                  }}
                />
              ))
            : null}
        </div>
      </TachometerBar>
    </ListDataLineChartSC>
  );
};

export default React.memo(ListDataLineChart);
